import React from 'react'
import MessageBubble from './MessageBubble'
import style from '../../chatModule/chatscreen.module.scss'


const Messages = ({ messages }) => {

  const messagesKeys = Object.keys(messages || {})
  return (
    <div className={style.chatBox}>
      {
        messagesKeys.length > 0 && messagesKeys.map((key) => {
          const currentMessage = messages[key]
          return <MessageBubble message={currentMessage} key={key} />
        })
      }
    </div>
  )
}
export default Messages

